import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Tab as HeadlessTab, Transition } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';
/**
 * Passing in <Tab> as direct children will use a simple implementation of tabs. If you need to add additional components to be inline with the <Tab>'s wrap them in the <TabListWrapper> component.
 */
export const Tabs = ({ children, className, panelsClassName, tabGroupProps, activeIndex, onChange, underlineNonActiveTabs }) => {
    const [activeTab, setActiveTab] = useState(0);
    const tabs = [];
    const panels = [];
    let tabListWrapper = null;
    useEffect(() => {
        if (activeIndex !== undefined)
            setActiveTab(activeIndex);
    }, [activeIndex]);
    React.Children.forEach(children, (child) => {
        if (!React.isValidElement(child))
            return;
        if (child.type === Tab) {
            tabs.push(child);
        }
        else if (child.type === TabPanel) {
            panels.push(child);
        }
        else if (child.type === TabListWrapper) {
            tabListWrapper = child;
        }
    });
    const handleTabChange = (index) => {
        setActiveTab(index);
        if (onChange)
            onChange(index);
    };
    return (_jsxs(HeadlessTab.Group, { ...tabGroupProps, children: [tabListWrapper ? (React.cloneElement(tabListWrapper, {
                activeTab,
                setActiveTab: handleTabChange,
                underlineNonActiveTabs,
            })) : (_jsx(HeadlessTab.List, { className: className, children: tabs.map((tab, index) => (_jsx(HeadlessTab, { style: { outline: 'none' }, className: twMerge('px-4 py-2 focus:ring-transparent', index === activeTab ? 'text-primary-400 border-primary-400 border-b-2' : '', underlineNonActiveTabs && index !== activeTab ? 'border-b-2 border-gray-400' : '', tab.props.className), onClick: () => handleTabChange(index), children: tab.props.children }, index))) })), _jsx(HeadlessTab.Panels, { className: panelsClassName, children: panels.map((panel, index) => (_jsx(Transition, { show: index === activeTab, enter: "transition-opacity duration-300", enterFrom: "opacity-0", enterTo: "opacity-100", as: React.Fragment, children: _jsx(HeadlessTab.Panel, { className: twMerge(`mt-2`, panel.props.className), static: true, children: panel.props.children }) }, index))) })] }));
};
export const Tab = ({ children }) => {
    if (!React.isValidElement(children)) {
        return _jsx("div", {});
    }
    return _jsx(_Fragment, { children: children });
};
export const TabPanel = ({ children }) => {
    if (!React.isValidElement(children)) {
        return _jsx("div", {});
    }
    return _jsx(_Fragment, { children: children });
};
export const TabListWrapper = ({ className, children, activeTab, setActiveTab, underlineNonActiveTabs, }) => {
    const tabs = [];
    const otherChildren = [];
    React.Children.forEach(children, (child) => {
        if (!React.isValidElement(child))
            return;
        if (child.type === Tab) {
            tabs.push(child);
        }
        else {
            otherChildren.push(child);
        }
    });
    return (_jsxs(HeadlessTab.List, { className: className, children: [tabs.map((tab, index) => (_jsx(HeadlessTab, { style: { outline: 'none' }, className: twMerge('px-4 py-2 focus:ring-transparent', index === activeTab ? 'text-primary-400 border-primary-400 border-b-2' : '', underlineNonActiveTabs && index !== activeTab ? 'border-b-2 border-gray-400' : '', tab.props.className), onClick: () => {
                    if (setActiveTab)
                        setActiveTab(index);
                }, children: tab.props.children }, index))), otherChildren] }));
};
//# sourceMappingURL=Tabs.js.map